import React from "react";
import PropTypes from "prop-types";

import { Facebook } from "../../atoms/icons/fb";
import WhatsApp from "../../atoms/icons/whatsapp";
import TwitterIcon from "../../atoms/icons/twitter";

import "./card-share.m.css";

const CardShareTemplate = ({ className, twitterUrl, fbUrl, whatsappUrl, color }) => {
  return (
    <div className={className}>
      <a styleName="icon" href={twitterUrl} target="_blank" rel="noopener noreferrer">
        <TwitterIcon color={color} width={18} height={18} />
      </a>
      <a styleName="icon" href={fbUrl} target="_blank" rel="noopener noreferrer">
        <Facebook color={color} width={18} height={18} />
      </a>
      <a styleName="icon" href={whatsappUrl} target="_blank" rel="noopener noreferrer">
        <WhatsApp color={color} width={20} height={20} />
      </a>
    </div>
  );
};

CardShareTemplate.propTypes = {
  color: PropTypes.string,
  twitterUrl: PropTypes.string,
  fbUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  className: PropTypes.string
};

export default CardShareTemplate;
